import React, { forwardRef } from "react";
import "./Table.css";

export const Table = forwardRef(function Table({ className = "", children, ...props }, ref) {
  return (
    <div className="ui-table-wrap">
      <table ref={ref} className={`ui-table ${className}`} {...props}>
        {children}
      </table>
    </div>
  );
});

export const THead = forwardRef(function THead({ children, ...props }, ref) {
  return <thead ref={ref} className="ui-thead" {...props}>{children}</thead>;
});

export const TBody = forwardRef(function TBody({ children, ...props }, ref) {
  return <tbody ref={ref} className="ui-tbody" {...props}>{children}</tbody>;
});

export const TR = forwardRef(function TR({ className = "", children, ...props }, ref) {
  return <tr ref={ref} className={`ui-tr ${className}`} {...props}>{children}</tr>;
});

export const TH = forwardRef(function TH({ className = "", children, align = "left", ...props }, ref) {
  return (
    <th ref={ref} className={`ui-th ${className}`} style={{ textAlign: align }} {...props}>
      {children}
    </th>
  );
});

export const TD = forwardRef(function TD({ className = "", children, align = "left", ...props }, ref) {
  return (
    <td ref={ref} className={`ui-td ${className}`} style={{ textAlign: align }} {...props}>
      {children}
    </td>
  );
});
